import { render, staticRenderFns } from "./StoreSummary.vue?vue&type=template&id=5fc606df&"
import script from "./StoreSummary.vue?vue&type=script&lang=ts&"
export * from "./StoreSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports